import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Accommodation from './pages/Accommodation';
import Resort from './pages/Resort';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <HelmetProvider>
          <Router>
            <ScrollToTop />
            <div className="min-h-screen bg-white dark:bg-gray-900">
              <Navigation />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/galeria" element={<Gallery />} />
                <Route path="/kontakt" element={<Contact />} />
                <Route path="/ubytovanie" element={<Accommodation />} />
                <Route path="/rezort" element={<Resort />} />
              </Routes>
              <Footer />
            </div>
          </Router>
        </HelmetProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
